<template>
<div class="navigate-web">
  <Error @reload="getData()" v-if="networkError" />
  <div class="navigate-wrapper" v-else>
    <div class="navigate" :style="inNavigation ? 'height: 0' : ''">
      <div class="navigate-top">
        <div class="navigate-form">
          <div class="current-location" @click="handleSelectStart">
            <img src="../assets/my-location.svg" />
            <div class="location">{{ start.name || '我的位置' }}</div>
          </div>
          <div class="destination" @click="handleSelectEnd">
            <img src="../assets/destination.svg" />
            <div class="location">{{ end.name }}</div>
          </div>
        </div>
        <div class="exchange" @click="handleExchange">
          <img src="../assets/exchange.svg" />
        </div>
      </div>
      <div class="navigate-tabs">
        <div class="tab-wrapper"
            v-for="(item, index) in tabs"
            :key="item.id">
          <div class="tab"
              :class="{'active': active === index}"
              @click="handleChangeTab(index)">
            <div class="icon">
              <img :src="item.img" />
            </div>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="navigate-route">
      <!-- <div class="card-wrapper">
        <Recommend :list="currentArray" v-show="active === 0 && !showMap" @showmap="handleShowMap" />
        <Bus :list="currentArray" v-show="active === 2 && !showMap" @showmap="handleShowMap" />
        <Cable :list="currentArray" v-show="active === 3 && !showMap" @showmap="handleShowMap" />
      </div> -->
      <div class="empty-wrapper" v-show="showEmpty">
        <empty content="未查询到合适的方案" />
      </div>
      <CMap ref="cmap"
            :endName="end.name"
            :activeIndex="currentIndex"
            :inNavigation="inNavigation"
            :alpha="alpha"
            :inThere="inThere"
            :web="true"
            :offset="26"
            @change="handleChangeRoute"
            @stop="handleStop" />
    </div>
    <!-- 搜索 -->
    <NavigateSearch :inThere="inThere" ref="navigateSearch" :geoData="geoData" @selectPlace="handleSelectPlace" />
    <transition name="fade">
      <RouteDetail ref="routeDetail"
                  v-if="!showEmpty"
                  v-show="!inNavigation"
                  :list="currentArray"
                  :startName="start.name"
                  :endName="end.name"
                  :iphoneX="iphoneX"
                  :offset="26"
                  :activeIndex="currentIndex"
                  @mask="handleMask" />
    </transition>
    <div class="start-nav"
        :class="{'shadow': showMask}"
        v-show="!inNavigation"
        v-if="currentArray && currentArray.length > 0 && (currentArray[currentIndex].meta.vehicle === 'foot' || currentArray[currentIndex].meta.vehicle === 'car') && !showEmpty">
      <div class="other-nav" @click="handleOthers">使用其他地图</div>
      <div class="start-btn" @click="handleNavigate">开始导航</div>    
    </div>
    <transition name="fade">
      <div class="mask" v-if="showMask" @click="closeRouteDetail"></div>
    </transition>
  </div>
</div>
</template>

<script>
import NavigateSearch from '@/components/navigate/NavigateSearch'
import CMap from '@/components/navigate/CMap'
import RouteDetail from '@/components/navigate/RouteDetail'
import empty from '@/components/empty'
import { getRouteDetail } from '@/fetch/api'
import { pointWithinThere } from '@/utils/index'
import _ from 'lodash'
import Error from '@/components/Error.vue'

export default {
  data () {
    return {
      start: {
        name: '',
        lon: '',
        lat: ''
      },
      end: {
        name: '',
        lon: '',
        lat: ''
      },
      active: 0,
      tabs: [
        { id: 1, name: '智行', type: 'suggest', img: '/image/navigate/zhi-xing.svg', component: 'Recommend' },
        { id: 2, name: '驾车', type: 'car', img: '/image/navigate/car-white.svg', component: 'Car' },
        { id: 3, name: '步行', type: 'foot', img: '/image/navigate/walk.svg', component: 'Walk' },
        { id: 4, name: '巴士', type: 'bus', img: '/image/navigate/bus-white.svg', component: 'Bus' }
      ],
      suggested: [],
      routes: {},
      showEmpty: false,
      currentArray: [
        {
          paths: [
            { time: null, distance: null }
          ],
          meta: { weighting: '' }
        }
      ],
      currentIndex: 0,
      showMap: false,
      showMask: false,
      geoData: {
        lon: '',
        lat: ''
      },
      inThere: false,
      inNavigation: false,
      alpha: 0,
      noPermission: false,
      iphoneX: false,
      Android: false,
      networkError: false
    }
  },
  components: {
    NavigateSearch,
    empty,
    CMap,
    RouteDetail,
    Error
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    }
  },
  created () {
    this.toast = this.$createToast({
      time: 0,
      txt: '加载中...',
      mask: true
    })
    this.toast.show()
    // document.title = '导航'
    console.log(JSON.parse(decodeURIComponent(this.$route.params.data)))
    const [startLon, startLat, startName, endLon, endLat, endName] = JSON.parse(decodeURIComponent(this.$route.params.data))
    this.start = {
      name: startName,
      lon: startLon,
      lat: startLat
    }
    this.end = {
      name: endName,
      lon: endLon,
      lat: endLat
    }
    const navigator = window.navigator
    const Android = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    const iphoneX = /iphone/gi.test(navigator.userAgent) && (screen.height >= 812)
    this.iphoneX = iphoneX
    this.Android = Android
    this.startUpdateLocation(startLon)
    if (startLon) { // 指定起始点时，有值
      this.$nextTick(() => {
        console.log('初始化，有起始点，请求数据')
        this.getData()
      })
      console.log('kjkljgl=====', startLon)
    } else {
      console.log('初始化，没有有起始点========')
      navigator.geolocation.getCurrentPosition((res) => {
        const longitude = res.coords.longitude
        const latitude = res.coords.latitude
        // console.log(longitude, latitude)
        if (longitude) {
          const inThere = pointWithinThere(longitude, latitude)
          this.inThere = inThere
          if (!inThere && !startLon) {
            this.$createDialog({
              type: 'alert',
              content: '亲，你的当前位置不在德国。导航起点默认设为勃兰登堡⻔'
            }).show()
            this.start = {
              name: '勃兰登堡⻔',
              lon: 12.526366,
              lat: 52.413194
            }
          } else {
            this.start = {
              name: '',
              lon: longitude,
              lat: latitude
            }
          }
          this.$nextTick(() => {
            console.log('========获取到了用户位置，请求数据')
            this.getData()
          })
        }
      }, err => {
        console.log(err)
        this.$createDialog({
          type: 'alert',
          content: '亲，你的当前位置不在德国。导航起点默认设为勃兰登堡⻔'
        }).show()
        this.start = {
          name: '勃兰登堡⻔',
          lon: 12.526366,
          lat: 52.413194
        }
        this.$nextTick(() => {
          console.log('获取用户位置失败，请求数据')
          this.getData()
        })
      }, { timeout: 5000, enableHighAccuracy: true })
    }
  },
  beforeDestroy () {
    this.handleStopMonitor()
  },
  methods: {
    handleOrientation (res) {
      const alpha = res.webkitCompassHeading
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.$nextTick(() => {
        this.$refs.cmap.updateStatus(null, alpha)
      })
    },
    handleOrientationAbsolute (res) {
      const alpha = 360 - res.alpha
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.$nextTick(() => {
        this.$refs.cmap.updateStatus(null, alpha)
      })
    },
    // 获取角度、位置信息
    startUpdateLocation () {
      if (this.Android) {
        window.addEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
      } else {
        window.addEventListener('deviceorientation', this.handleOrientation)
      }
      this.watchId = window.navigator.geolocation.watchPosition((res) => {
        const longitude = res.coords.longitude
        const latitude = res.coords.latitude
        // console.log(longitude, latitude)
        if (longitude) {
          this.geoData = {
            lon: longitude,
            lat: latitude
          }
          this.$nextTick(() => {
            this.$refs.cmap.updateStatus(this.geoData, '')
          })
        }
      }, err => {
        console.log(err)
        this.toast = this.$createToast({
          type: 'txt',
          txt: '网络异常，请稍后重试！'
        })
        this.toast.show()
      }, { timeout: 10000, enableHighAccuracy: true })
    },
    getData (index) {
      if (this.start.lat === this.end.lat && this.start.lon === this.end.lon) {
        this.toast = this.$createToast({
          txt: '终点不可与起点相同',
          mask: true
        })
        this.toast.show()
      }
      getRouteDetail({
        start_lat: this.start.lat,
        start_lon: this.start.lon,
        end_lat: this.end.lat,
        end_lon: this.end.lon
      }).then(res => {
        this.toast.hide()
        // 智能推荐
        let suggested = []
        res.routes = res.routes.filter(item => item.meta)
        // 时间最短排前面
        res.routes.sort((a, b) => {
          return a.meta.weighting.localeCompare(b.meta.weighting)
        })
        res.routes.forEach(route => {
          // 处理路线
          let routes = []
          const startPoint = route.meta.point[0].split(',')
          const endPoint = route.meta.point[1].split(',')
          const firstCoordinates = route.paths[0].points.coordinates.slice(0, 1)[0]
          const lastCoordinates = route.paths[0].points.coordinates.slice(route.paths[0].points.coordinates.length - 1)[0]
          console.log(startPoint, endPoint, firstCoordinates, lastCoordinates)
          route.paths[0].points.coordinates.unshift([parseFloat(startPoint[1]), parseFloat(startPoint[0]), firstCoordinates[2], firstCoordinates[3], firstCoordinates[4]])
          route.paths[0].points.coordinates.push([parseFloat(endPoint[1]), parseFloat(endPoint[0]), lastCoordinates[2], lastCoordinates[3], lastCoordinates[4]])
          if (route.paths[0].points.coordinates.every(point => point[2] === 0)) {
            route.meta.vehicle = 'foot'
          }
          route.paths[0].points.coordinates.forEach((item, index) => {
            const type = item[2]
            if (routes.length === 0 || routes[routes.length - 1].type !== type) {
              if (routes.length > 0) {
                console.log(routes.length)
                const copyItem = item.slice(0, 5)
                copyItem[2] = routes[routes.length - 1].type
                routes[routes.length - 1].array.push(copyItem)
              }
              routes.push({
                type: item[2],
                array: [item]
              })
            } else {
              routes[routes.length - 1].array.push(item)
            }
          })
          route.routeArray = routes
          routes.forEach((item, index) => {
            item.tIndex = this.findBus(route, index)
          })
          if (route.meta.suggested) {
            suggested.push(route)
          }
        })
        const data = _.groupBy(res.routes, 'meta.vehicle')
        this.suggested = suggested
        if (index) {
          const currentArray = data[this.tabs[index].type]
          this.currentArray = currentArray
          if (currentArray.length === 0) {
            this.showEmpty = true
            this.$refs.cmap.hideMap()
          } else {
            this.showEmpty = false
            this.$refs.cmap.showMap(this.tabs[index].type, currentArray, this.geoData)
          }
        } else {
          this.currentArray = suggested
          if (suggested.length === 0) {
            this.showEmpty = true
            this.$refs.cmap.hideMap()
          } else {
            this.showEmpty = false
            this.$refs.cmap.showMap('suggest', suggested, this.geoData)
          }
        }
        this.routes = data
        this.networkError = false
      }).catch(err => {
        console.log(err)
        this.toast.hide()
        this.networkError = true
      })
    },
    handleChangeTab (index) {
      this.active = index
      this.currentIndex = 0
      if (index === 0) {
        this.currentArray = this.suggested
        if (this.suggested.length === 0) {
          this.showEmpty = true
          this.$refs.cmap.hideMap()
        } else {
          this.showEmpty = false
          this.$refs.cmap.showMap('suggest', this.suggested)
        }
      } else {
        const currentArray = this.routes[this.tabs[index].type]
        this.currentArray = currentArray
        if (!currentArray || currentArray.length === 0) {
          this.showEmpty = true
          this.$refs.cmap.hideMap()
        } else {
          this.showEmpty = false
          this.$refs.cmap.showMap(this.tabs[index].type, currentArray)
        }
      }
    },
    // 在地图上显示路线
    handleShowMap (detail) {
      this.$refs.cmap.showMap(detail.type, this.currentArray, detail.index)
      // this.showMap = true
    },
    // 选择起点
    handleSelectStart () {
      this.$refs.navigateSearch.show('start')
    },
    // 选择终点
    handleSelectEnd () {
      this.$refs.navigateSearch.show('end')
    },
    handleExchange () {
      let oldStart = Object.assign({}, this.start)
      this.start = Object.assign({}, this.end)
      this.end = oldStart
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      this.$nextTick(() => {
        console.log('交换了起止位置，请求数据')
        this.getData(this.active)
      })
    },
    // 根据搜索结果设置起止点
    handleSelectPlace (data) {
      if (data.type === 'start') {
        if (!data.detail.lon) {
          this.$createDialog({
            type: 'alert',
            content: '亲，你的当前位置不在德国。导航起点默认设为勃兰登堡⻔'
          }).show()
          this.start = {
            name: '勃兰登堡⻔',
            lon: 12.526366,
            lat: 52.413194
          }
        } else {
          this.start = {
            name: data.detail.name,
            lon: data.detail.lon,
            lat: data.detail.lat
          }
        }
      } else {
        this.end = {
          name: data.detail.name,
          lon: data.detail.lon,
          lat: data.detail.lat
        }
      }
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      this.$nextTick(() => {
        if (this.start.lon && this.end.lon) {
          console.log('选择了搜索结果，请求数据')
          this.getData(this.active)
        }
      })
    },
    handleChangeRoute (index) {
      this.currentIndex = index
    },
    // 找到bus在transporation中的index
    findBus (route, realIndex) {
      let order = 0
      for (let i = 0; i < route.routeArray.length; i++) {
        const item = route.routeArray[i]
        if (item.type !== 0 && item.type !== 7) {
          if (i === realIndex) {
            return order
          }
          order += 1
        }
      }
      return ''
    },
    handleMask (value) {
      this.showMask = value
    },
    // 点击开始导航
    handleNavigate () {
      console.log('当前状态', this.inThere)
      if (!this.inThere) {
        let text = ''
        if (this.siteId === '245') {
          text = '亲，你的当前位置不在RWS'
        } else if (this.siteId === '129') {
          text = '亲，你的当前位置不在新加坡'
        } else if (this.siteId === '33') {
          text = '亲，你的当前位置不在德国'
        } else {
          text = '亲，你的当前位置不在圣淘沙'
        }
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: text
        })
        this.toast.show()
        return
      }
      if (this.geoData && this.geoData.lon) {
        this.$refs.routeDetail.handleClose()
        this.inNavigation = true
        this.$nextTick(() => {
          this.$refs.cmap.startNavigate(this.geoData)
        })
      } else {
        this.toast = this.$createToast({
          type: 'txt',
          txt: '未获取到您的位置，请稍后重试！'
        })
        this.toast.show()
      }
    },
    handleStopMonitor () {
      if (this.Android) {
        window.removeEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
      } else {
        window.removeEventListener('deviceorientation', this.handleOrientation)
      }
      window.navigator.geolocation.clearWatch(this.watchId)
    },
    handleStop () {
      this.inNavigation = false
    },
    closeRouteDetail () {
      this.$refs.routeDetail.handleClose()
    },
    // 使用其他地图
    handleOthers () {
      window.wx.miniProgram.postMessage({
        data: {
          lon: 12.526366,
          lat: 52.413194
        }
      })
      window.wx.miniProgram.navigateBack()
    }
  }
}
</script>

<style lang="scss" scoped>
.navigate {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  z-index: 10;
  background-color: #ffffff;
  height: 130px;
  transition: height 0.2s ease-in-out;
  overflow: hidden;

  &-wrapper {
    position: relative;
    height: 100vh;
    overflow: hidden;
  }
  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 0 0 12px;
  }

  .current-location {
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    height: 32px;

    img {
      width: 24px;
      height: 24px;
      display: block;
      margin-right: 6px;
    }
  }

  .location {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    font-size: 14px;
    line-height: 24px;
    color: #222215;
  }

  .destination {
    margin-top: 8px;
    background-color: #f3f3f3;
    display: flex;
    align-items: center;
    height: 32px;
    img {
      width: 24px;
      height: 24px;
      display: block;
      margin-right: 6px;
    }

    .navigate-input {
      width: 100%;
      height: 32px;
      background-color: transparent;
      font-size: 14px;
      line-height: 32px;
      margin-left: 6px;
    }
  }

  &-form {
    flex: 1;
    width: calc(100% - 56px);
  }

  .exchange {
    width: 56px;
    height: 60px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-tabs {
    display: flex;
    font-size: 14px;
    color: #888888;
    padding: 12px;
    transition: all 0.3s ease-out;
    justify-content: space-between;
    display: flex;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);

    .tab-wrapper {
      width: 60px;
    }

    .tab {
      width: 45px;
      white-space: nowrap;
      height: 22px;
      text-align: center;
      line-height: 22px;
      border-radius: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      // transition: width 0.3s ease-out;
      transition: all 0.2s ease-in-out;

      .icon {
        width: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
        opacity: 0;
      }

      &.active {
        color: #ffffff;
        font-weight: bold;
        font-family: GothamBold;
        background-color: #f8a909;
        width: 60px;
        .icon {
          opacity: 1;
        }
      }
    }
  }

  &-route {
    height: 100vh;
    background-color: #f7f7f7;
  }
}

.empty-wrapper {
  padding-top: 130px;
  height: 100%;
}
.start-nav {
  padding: 12px 0 12px;
  margin-bottom: env(safe-area-inset-bottom);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;

  &.shadow {
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    &.after {
      display: none;
    }
  }

  .start-btn,
  .other-nav {
    width: 160px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  .start-btn {
    color: #ffffff;
    background-color: #f8a909;
    margin-left: 12px;
  }

  .other-nav {
    color: #222125;
    border: solid 1px #222125;
  }

  &:after {
    width: calc(100% - 24px);
    content: '';
    height: 1px;
    background-color: #efefef;
    position: absolute;
    left: 12px;
    top: 0;
  }
}

.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(34, 33, 37, 0.75);
  z-index: 10;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
